import { Value } from '@philips-internal/oswald-ui-core';
import { FetchAPI, FormAPI } from '@philips-internal/oswald-ui-components';
import Controller, { OnBeforeFetch, OnBeforeSubmit, OnEdit, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { EditEvent, FetchEvent, MountEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { SubmitEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import './health-information-controller.css';
import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { APPLICATION_ENDPOINTS } from '../../constants/application-endpoints';
import { HttpResponse } from '@philips-internal/oswald-ui-core/lib/services/http-service';
import { Inject } from '@odinjs/odin';
import { ToastResponse } from '../../interfaces/ToastResponse';
import { showToastNotificationMessage } from '../../utils/toast-notification-utils';
import UserContext from '../../utils/user-context';
import ProfileModalUploadService from '../../services/profile-modal-upload-service';
import { HealthInformationAliases } from '../../codegen';
import ProfileBaseController from '../profile-base-controller';
import { HttpServiceError, PatientHttpService } from '../../services/patient-http-service';

interface FieldTypes {
  dsValorNew: Value;
  dsValorOld: Value;
  nmAtributo: string;
}

interface FieldsValue {
  height: number;
  weight: number;
}

interface FieldsRequireProof {
  dsDocumento: string;
  ieAttributo: string;
  nrSequenciaDoc: number;
}
@Controller({fragment: 'health-information'})
export default class HelthInformationController extends ProfileBaseController {

  @Inject('health-infor-fetch')
    fecthHealthInfo!: FetchAPI;

  @Inject('health-form')
    formHealth!: FormAPI;

  @OnMount(HealthInformationAliases.HEALTH_FORM)
  onMountHealthForm(event: MountEvent): void {
    const formApi = event.target as FormAPI;
    super.setContextVariablesForTaskModule();
    super.listenWhetherProfileEditingIsEnabled(formApi);
  }

  @OnEdit({target: 'health-form'})
  onEditForm(event: EditEvent):void{
    const form = event.target as FormAPI;
    this.context.set({ oldFormValues: form.getData() });
  }

  @OnBeforeFetch({ target: HealthInformationAliases.HEALTH_INFOR_FETCH})
  handleBeforeFetchContactInformation(event: FetchEvent): void {
    const fetchHealthInformation = event.target as FetchAPI;
    fetchHealthInformation.setParameters({ personCode: UserContext.patientId });
  }

  @OnBeforeSubmit({ target: ['health-form'] })
  onBeforeSubmitEvent(event: SubmitEvent): void {

    const campos: FieldTypes[] = [];
    const insertVal: Record<string, Value>[] = [];
    const newValues = event.record as Record<string, FieldsValue>;
    const oldValues = this.context.get('oldFormValues') as Record<string, FieldsValue>;
    const body = { campos, insertVal };
    const updatedFields: string[] = [];

    Object.keys(newValues).forEach(key => {
      if(oldValues && oldValues[key] !== newValues[key]) {
        updatedFields.push(key.toUpperCase());
        const oldV = oldValues[key];
        const newV = newValues[key];
        body.campos.push({
          dsValorNew: newV ? newV.weight || newV.height || newV : '',
          dsValorOld: oldV ? oldV.weight || oldV.height || oldV : '',
          nmAtributo: key,
        });
      }
    });

    if(body.campos.length === 0 ){
      return ;
    }

    HttpService.get(APPLICATION_ENDPOINTS.GET_FIELDS_REQUIRE_PROOF).then((resp: HttpResponse<unknown>) => {
      const { body: bodyResponse } = resp as HttpResponse<FieldsRequireProof[]>;
      const fieldsRequireProof = bodyResponse && bodyResponse
        .filter(doc => updatedFields.some((updatedField) => updatedField === doc.ieAttributo.replace(/_/g, '')))
        .map(doc => ({
          attribute: doc.ieAttributo,
          key: doc.nrSequenciaDoc.toString(),
          required: true,
          value: doc.dsDocumento,
        }));

      if (fieldsRequireProof && fieldsRequireProof.length > 0) {
        ProfileModalUploadService.open({
          bodyToUpdate: body,
          mandatoryAttachmentsFields: fieldsRequireProof,
          onConfirmUpload: e => this.sendUpdateRequest(e.record),
        });
      } else {
        this.sendUpdateRequest(body);
      }
    });
  }

  sendUpdateRequest(body: Record<string, Value>): void {
    this.formHealth.setLoading(true);
    PatientHttpService.post<ToastResponse>(APPLICATION_ENDPOINTS.POST_PROFILE_INFORMATION, { patientId: UserContext.patientId }, { body })
      .then((response) => {
        this.handleResponse(response);
        this.fecthHealthInfo.forceFetch();
      }).catch(({ response }: HttpServiceError<ToastResponse>) => {
        this.handleResponse(response);
      }).finally(() =>{this.formHealth.setLoading(false)});

  }

  handleResponse(resp?: HttpResponse<ToastResponse>): void {
    if (resp?.body) {
      showToastNotificationMessage(resp.body);
    }
  }
}